/*
 * Icon Registry for consistent icon usage, type safety, and tree-shaking.
 */

import {
  createLucideIcon,
  AlertCircle,
  AlignLeft,
  Archive,
  ArchiveRestore,
  ArrowDown,
  ArrowLeft,
  ArrowLeftIcon,
  ArrowRightCircle,
  ArrowRightLeft,
  ArrowRightIcon,
  ArrowUp,
  ArrowUpDown,
  ArrowUpRight,
  ArrowUpRightIcon,
  AtSign,
  AudioLines,
  Ban,
  BarChart2,
  BellDot,
  Bold,
  BookOpen,
  BookText,
  Box,
  Bot,
  Brain,
  Bug,
  Calendar,
  CalendarClock,
  CalendarDays,
  CalendarPlus,
  CalendarX2,
  Camera,
  CaseSensitive,
  Check,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDownUp,
  ChevronsRight,
  ChevronsUpDown,
  ClipboardPaste,
  Circle,
  CircleArrowUp,
  CircleCheck,
  CircleX,
  Contrast,
  CircleDashed,
  Clock,
  Code,
  Columns3,
  Command,
  CopyIcon,
  CreditCard,
  Crown,
  Database,
  DoorOpen,
  Download,
  Eraser,
  Expand,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileImage,
  FileText,
  FilePlus2,
  FileX2,
  Filter,
  ListFilter,
  Fingerprint,
  Folder,
  FolderMinus,
  FolderOpen,
  FolderPlus,
  FolderTree,
  Gift,
  GitBranch,
  Globe,
  Grid2x2Plus,
  GripHorizontal,
  GripVertical,
  Hand,
  Hash,
  Heading,
  Heading2,
  Heading3,
  Headphones,
  Highlighter,
  HistoryIcon,
  Home,
  ImageOff,
  Images,
  Inbox,
  Info,
  Italic,
  LayoutGrid,
  Lightbulb,
  Link,
  List,
  Lock,
  ListCheckIcon,
  ListOrdered,
  Loader,
  LogOut,
  Mail,
  MailOpen,
  Maximize2,
  Merge,
  Minimize2,
  Minus,
  Menu,
  MessageCircle,
  MessageCirclePlus,
  MessageCircleMore,
  MessageCircleWarning,
  MessageSquareShare,
  MessagesSquare,
  Mic,
  MicOff,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  NotebookText,
  NotepadText,
  OctagonAlert,
  PaintBucket,
  Paperclip,
  Pause,
  Pencil,
  PictureInPicture,
  PictureInPicture2,
  PencilLine,
  Pin,
  Play,
  PlugZap,
  PlusIcon,
  Puzzle,
  RefreshCcwIcon,
  RefreshCw,
  Repeat2,
  ReplaceAll,
  Reply,
  Rocket,
  RotateCwSquare,
  Unlink,
  ZoomIn,
  ZoomOut,
  Rows2,
  Rows3,
  Rows4,
  Scan,
  Search,
  Send,
  Settings,
  Settings2,
  ShapesIcon,
  Share,
  Share2Icon,
  ShieldAlert,
  ShieldCheck,
  ShieldQuestionMark,
  Shrink,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SlidersHorizontal,
  SparklesIcon,
  Split,
  Square,
  SquareArrowOutUpRight,
  SquareCheck,
  SquareCheckBig,
  SquareFunction,
  SquareIcon,
  SquarePen,
  SquareSplitHorizontal,
  SquareTerminal,
  SquareX,
  Star,
  Stars,
  StickyNote,
  Strikethrough,
  Sun,
  Table,
  Tag,
  Tags,
  Telescope,
  TextIcon,
  TextQuote,
  TextSelect,
  ThumbsDown as ThumbsDownIcon,
  ThumbsUp as ThumbsUpIcon,
  Trash,
  Trash2,
  TriangleAlert,
  Type,
  Underline,
  Undo,
  Undo2,
  Upload,
  User,
  UserPlus,
  Users,
  UserSearch,
  Vault,
  Video,
  Volume2,
  VolumeX,
  Wallet,
  WandSparkles,
  WifiOff,
  X,
  Zap,
  ZapOff,
  SparkleIcon,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRight,
  PanelRightClose,
  Shuffle,
  FaceSlightlySmiling,
  MicAudioLines,
  PencilSparkles,
  Shield,
  Banknote,
  BicepsFlexed,
  Bird,
  Birdhouse,
  BriefcaseBusiness,
  ChartGantt,
  ChartNoAxesCombined,
  ChefHat,
  ChessKnight,
  ClockFading,
  Cookie,
  Feather,
  GalleryVerticalEnd,
  Fish,
  Gauge,
  Ghost,
  GitPullRequest,
  Guitar,
  HandCoins,
  HatGlasses,
  Image,
  Landmark,
  LifeBuoy,
  ListChecks,
  Package,
  PartyPopper,
  PawPrint,
  PenLine,
  Piano,
  PiggyBank,
  Scale,
  ShoppingBasket,
  Swords,
  TentTree,
  TreePalm,
  Trees,
  AlarmClock,
  Atom,
  Award,
  Bell,
  Bike,
  Briefcase,
  Building2,
  Cake,
  Car,
  Cloud,
  Coffee,
  Compass,
  Cpu,
  Dog,
  Droplet,
  Dumbbell,
  Film,
  Flag,
  Flame,
  FlaskConical,
  Flower2,
  Gamepad2,
  Gem,
  GraduationCap,
  Hammer,
  Handshake,
  Heart,
  KeyRound,
  Laptop,
  Leaf,
  LineChart,
  Map,
  MapPin,
  Megaphone,
  Microscope,
  Mountain,
  Music,
  Palette,
  Phone,
  PieChart,
  Pizza,
  Plane,
  Presentation,
  Scissors,
  Server,
  Ship,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Smile,
  SmilePlus,
  Snowflake,
  Sprout,
  Stethoscope,
  Target,
  Ticket,
  TreePine,
  Trophy,
  Truck,
  Utensils,
  Waves,
  Wifi,
  Wrench,
  PanelLeft as LucidePanelLeft,
  Delete,
} from 'lucide-react';
import {
  type ComponentProps,
  type ComponentRef,
  forwardRef,
  type ForwardRefExoticComponent,
  type RefAttributes,
  type SVGProps,
} from 'react';

import { AppleIcon, AppleOutlineIcon } from './apple';
import { AppleCalendarIcon } from './apple-calendar';
import { AppleContactsIcon } from './apple-contacts';
import { AppleRemindersIcon } from './apple-reminders';
import { DatadogIcon } from './datadog';
import { DiscordIcon } from './discord';
import { DropboxIcon } from './dropbox';
import { GmailIcon } from './gmail';
import { GoogleIcon } from './google';
import { GoogleCalendarIcon } from './google-calendar';
import { GoogleDocsIcon } from './google-docs';
import { GoogleDriveIcon } from './google-drive';
import { GoogleFormsIcon } from './google-forms';
import { GoogleMeetIcon } from './google-meet';
import { GoogleSheetsIcon } from './google-sheets';
import { GoogleTasksIcon } from './google-tasks';
import { GoToMeetingIcon } from './gotomeeting';
import { LinkedinIcon } from './linkedin';
import { McpIcon } from './mcp';
import { MetabaseIcon } from './metabase';
import { MicrosoftIcon } from './microsoft';
import { OutlookIcon } from './microsoft-outlook';
import { MicrosoftTeamsIcon } from './microsoft-teams';
import { RedditIcon } from './reddit';
import { SlackIcon } from './slack';
import { SnowflakeBrandIcon } from './snowflake';
import { TodoistIcon } from './todoist';
import { WebexIcon } from './webex';
import { WherebyIcon } from './whereby';
import { XTwitterIcon } from './x-twitter';
import { ZohoIcon } from './zoho';
import { ZoomIcon } from './zoom';

type SVGAttributes = Partial<SVGProps<SVGSVGElement>>;
type LBIconProps = SVGAttributes & {
  size?: string | number;
  absoluteStrokeWidth?: boolean;
};
export type LBIcon = ForwardRefExoticComponent<
  LBIconProps & RefAttributes<SVGSVGElement>
>;

const StarFilled = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => <Star fill="currentColor" {...props} ref={ref} />
);

const SquareFilled = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => <SquareIcon fill="currentColor" {...props} ref={ref} />
);

const PlayFilled = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => <Play fill="currentColor" {...props} ref={ref} />
);

const PauseFilled = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => <Pause fill="currentColor" {...props} ref={ref} />
);

const PinFilled = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => <Pin fill="currentColor" {...props} ref={ref} />
);

const MoreHorizontalFilled = forwardRef<
  ComponentRef<LBIcon>,
  ComponentProps<LBIcon>
>((props, ref) => <MoreHorizontal fill="currentColor" {...props} ref={ref} />);

const LayoutFreeform = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={ref}
    >
      <rect width="7" height="7" x="3" y="3" rx="1" />
      <rect width="7" height="7" x="14" y="4" rx="1" />
      <rect width="7" height="7" x="4" y="14" rx="1" />
    </svg>
  )
);

const PanelLeft = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
      ref={ref}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path d="M9 4v16" />
      <path d="M14 10l2 2l-2 2" />
    </svg>
  )
);

const PanelRightOpen = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      {...props}
      ref={ref}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path d="M15 4v16" />
      <path d="M10 10l-2 2l2 2" />
    </svg>
  )
);

const PanelRightCollapse = forwardRef<
  ComponentRef<LBIcon>,
  ComponentProps<LBIcon>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
    ref={ref}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
    <path d="M15 4v16" />
    <path d="M8 10l2 2l-2 2" />
  </svg>
));

const SummaryLines = forwardRef<ComponentRef<LBIcon>, ComponentProps<LBIcon>>(
  (props, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
      ref={ref}
    >
      <path d="M21 5H3" />
      <path d="M9 12H3" />
      <path d="M10 19H3" />
      <path d="M17.7874 18.8962C17.8682 18.8291 17.923 18.7359 17.9422 18.6327C18.0974 17.7102 18.5362 16.8591 19.1976 16.1976C19.8591 15.5362 20.7102 15.0974 21.6327 14.9422C21.7359 14.923 21.8291 14.8682 21.8962 14.7874C21.9633 14.7067 22 14.605 22 14.5C22 14.395 21.9633 14.2933 21.8962 14.2126C21.8291 14.1318 21.7359 14.077 21.6327 14.0578C20.7102 13.9026 19.8591 13.4638 19.1976 12.8024C18.5362 12.1409 18.0974 11.2898 17.9422 10.3673C17.923 10.2641 17.8682 10.1709 17.7874 10.1038C17.7067 10.0367 17.605 10 17.5 10C17.395 10 17.2933 10.0367 17.2126 10.1038C17.1318 10.1709 17.077 10.2641 17.0578 10.3673C16.9026 11.2898 16.4638 12.1409 15.8024 12.8024C15.1409 13.4638 14.2898 13.9026 13.3673 14.0578C13.2641 14.077 13.1709 14.1318 13.1038 14.2126C13.0367 14.2933 13 14.395 13 14.5C13 14.605 13.0367 14.7067 13.1038 14.7874C13.1709 14.8682 13.2641 14.923 13.3673 14.9422C14.2898 15.0974 15.1409 15.5362 15.8024 16.1976C16.4638 16.8591 16.9026 17.7102 17.0578 18.6327C17.077 18.7359 17.1318 18.8291 17.2126 18.8962C17.2933 18.9633 17.395 19 17.5 19C17.605 19 17.7067 18.9633 17.7874 18.8962Z" />
    </svg>
  )
);

const TranscriptLines = forwardRef<
  ComponentRef<LBIcon>,
  ComponentProps<LBIcon>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    ref={ref}
  >
    <path d="M19.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5Z" />
    <path d="M6.5 17.5H11.5M6.5 9.5H9.5M12.5 13.5H17.5" />
  </svg>
));

// ponytail: inline Lucide square-text until the installed release includes it
const SquareText = createLucideIcon('square-text', [
  ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2', key: 'box' }],
  ['path', { d: 'M7 8h8', key: 'top' }],
  ['path', { d: 'M7 12h10', key: 'middle' }],
  ['path', { d: 'M7 16h6', key: 'bottom' }],
]);

const CalendarAudioLines = createLucideIcon('calendar-audio-lines', [
  ['path', { d: 'M8 2v3', key: 'ring-left' }],
  ['path', { d: 'M16 2v3', key: 'ring-right' }],
  [
    'path',
    {
      d: 'M21 10V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6',
      key: 'page',
    },
  ],
  ['path', { d: 'M3 9h18', key: 'header' }],
  ['path', { d: 'M14.5 16v3', key: 'bar-left' }],
  ['path', { d: 'M17.75 13v9', key: 'bar-middle' }],
  ['path', { d: 'M21 15.5v4', key: 'bar-right' }],
]);

const iconRegistry = {
  routines: RefreshCw,
  createRoutines: CalendarPlus,
  journal: BookOpen,
  bookText: BookText,
  todos: CheckCircle2,
  sendToChat: MessageSquareShare,
  check: Check,
  clock: Clock,
  plus: PlusIcon,
  puzzle: Puzzle,
  stop: SquareFilled,
  stopAlt: Square,
  transcripts: TranscriptLines,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronsDownUp: ChevronsDownUp,
  chevronsRight: ChevronsRight,
  chevronsUpDown: ChevronsUpDown,
  download: Download,
  search: Search,
  research: Telescope,
  tags: Tags,
  attendees: Users,
  undo: Undo,
  trash: Trash,
  trash2: Trash2,
  terminal: SquareTerminal,
  circle: Circle,
  circleCheck: CircleCheck,
  circleHalf: Contrast,
  circleX: CircleX,
  arrowRightLeft: ArrowRightLeft,
  circleDashed: CircleDashed,
  restore: Undo2,
  sparkle: SparkleIcon,
  sparkles: SparklesIcon,
  wandSparkles: WandSparkles,
  vault: Vault,
  lightbulb: Lightbulb,
  edit: Pencil,
  loader: Loader,
  calendar: Calendar,
  calendarClock: CalendarClock,
  calendarPlus: CalendarPlus,
  camera: Camera,
  caseSensitive: CaseSensitive,
  speech: MessageCircle,
  dictation: AudioLines,
  calendarOverdue: CalendarX2,
  settings: Settings2,
  cog: Settings,
  reset: Settings,
  chat: MessagesSquare,
  write: PencilLine,
  notepad: NotepadText,
  memory: Brain,
  thought: Lightbulb,
  home: Home,
  meetings: CalendarAudioLines,
  insights: BarChart2,
  evals: NotebookText,
  debug: Bug,
  mcp: McpIcon,
  ingestion: Database,
  inbox: Inbox,
  privacyControls: ShieldCheck,
  dataControls: Database,
  navigateLeft: ArrowLeftIcon,
  navigateRight: ArrowRightIcon,
  arrowRight: ArrowRightCircle,
  arrowUpRight: ArrowUpRightIcon,
  goToIcon: ArrowUpRightIcon,
  star: Star,
  share: Share,
  shareWeb: Share2Icon,
  info: Info,
  refresh: RefreshCcwIcon,
  summary: ListCheckIcon,
  summarize: SummaryLines,
  feedback: MessageCircleWarning,
  discord: DiscordIcon,
  copy: CopyIcon,
  copyImage: Images,
  paste: ClipboardPaste,
  externalLink: ExternalLink,
  externalLink2: ArrowUpRight,
  pictureInPicture: PictureInPicture,
  pictureInPicture2: PictureInPicture2,
  notification: BellDot,
  cancel: X,
  backspace: Delete,
  arena: Split,
  gitBranch: GitBranch,
  atSign: AtSign,
  signal: Signal,
  signalHigh: SignalHigh,
  signalMedium: SignalMedium,
  signalLow: SignalLow,
  smilePlus: SmilePlus,
  shrink: Shrink,
  expand: Expand,
  scan: Scan,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
  rotateCw: RotateCwSquare,
  maximize: Maximize2,
  minimize: Minimize2,
  minus: Minus,
  more: MoreVertical,
  moreHorizontal: MoreHorizontalFilled,
  subscription: Stars,
  wallet: Wallet,
  invite: Mail,
  mail: Mail,
  mailOpen: MailOpen,
  connectionProblem: WifiOff,
  starFilled: StarFilled,
  panelLeft: PanelLeft,
  sidebar: LucidePanelLeft,
  panelRight: PanelRight,
  panelRightOpen: PanelRightOpen,
  panelLeftClose: PanelLeftClose,
  panelLeftOpen: PanelLeftOpen,
  panelRightClose: PanelRightClose,
  panelRightCollapse: PanelRightCollapse,

  drawer: Menu,
  gripHorizontal: GripHorizontal,
  gripVertical: GripVertical,
  quality: SparklesIcon,
  file: File,
  textFile: FileText,
  imageFile: FileImage,
  imageOff: ImageOff,
  lightTheme: Sun,
  darkTheme: Moon,
  systemTheme: Monitor,
  appearance: PaintBucket,
  paintBucket: PaintBucket,
  system: Monitor,
  plugZap: PlugZap,
  attachment: PlusIcon,
  fast: Zap,
  fastOff: ZapOff,
  send: ArrowUp,
  paperPlane: Send,
  recordAudio: Mic,
  recordAudioOff: MicOff,
  audio: Volume2,
  audioOff: VolumeX,
  filePlus: FilePlus2,
  noteError: FileX2,
  dataPrivacy: ShieldCheck,
  webSearch: Globe,
  selfKnowledge: BookOpen,
  contextSearch: UserSearch,
  messageSearch: MessageCircleMore,
  repeat2: Repeat2,
  link: Link,
  unlink: Unlink,
  lock: Lock,
  www: Globe,
  linkedin: LinkedinIcon,
  twitter: XTwitterIcon,
  reddit: RedditIcon,
  playground: ShapesIcon,
  type: Type,
  markdown: Code,
  paperclip: Paperclip,
  textSelect: TextSelect,
  code: Code,
  quote: TextQuote,
  numList: ListOrdered,
  todoList: CheckSquare,
  bulletList: List,
  list: List,
  layoutGrid: LayoutGrid,
  layoutFreeform: LayoutFreeform,
  heading3: Heading3,
  heading2: Heading2,
  heading1: Heading,
  text: TextIcon,
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strikeThrough: Strikethrough,
  highlighter: Highlighter,
  history: HistoryIcon,
  dot: Circle,
  newChat: MessageCircle,
  messageCirclePlus: MessageCirclePlus,
  sort: ArrowUpDown,
  requestPermission: ShieldAlert,
  mac: Command,
  warn: AlertCircle,
  warnOctagon: OctagonAlert,
  brokenImage: ImageOff,
  warnTriangle: TriangleAlert,
  thumbsUp: ThumbsUpIcon,
  thumbsDown: ThumbsDownIcon,
  user: User,
  userPlus: UserPlus,
  pause: Pause,
  pauseFilled: PauseFilled,
  play: PlayFilled,
  playAlt: Play,
  bot: Bot,
  fingerprint: Fingerprint,
  calendarDays: CalendarDays,
  upload: Upload,
  pin: Pin,
  replaceAll: ReplaceAll,
  reply: Reply,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  hash: Hash,
  alignLeft: AlignLeft,
  filter: Filter,
  listFilter: ListFilter,
  tag: Tag,
  creditCard: CreditCard,
  crown: Crown,
  circleArrowUp: CircleArrowUp,
  archive: Archive,
  restoreDocument: ArchiveRestore,
  apple: AppleIcon,
  appleOutline: AppleOutlineIcon,
  back: ArrowLeft,
  extras: Box,
  gmail: GmailIcon,
  google: GoogleIcon,
  appleCalendar: AppleCalendarIcon,
  appleContacts: AppleContactsIcon,
  appleReminders: AppleRemindersIcon,
  googleCalendar: GoogleCalendarIcon,
  googleDocs: GoogleDocsIcon,
  googleDrive: GoogleDriveIcon,
  dropbox: DropboxIcon,
  googleSheets: GoogleSheetsIcon,
  googleTasks: GoogleTasksIcon,
  googleForms: GoogleFormsIcon,
  outlook: OutlookIcon,
  microsoft: MicrosoftIcon,
  unpin: PinFilled,
  earlyAccess: Rocket,
  support: Headphones,
  square: Square,
  squareCheck: SquareCheck,
  squareCheckBig: SquareCheckBig,
  squareX: SquareX,
  squarePen: SquarePen,
  squareText: SquareText,
  squareFunction: SquareFunction,
  doorOpen: DoorOpen,
  logOut: LogOut,
  folder: Folder,
  folderMinus: FolderMinus,
  folderOpen: FolderOpen,
  folderPlus: FolderPlus,
  folderTree: FolderTree,
  ban: Ban,
  hand: Hand,
  slidersHorizontal: SlidersHorizontal,
  book: BookOpen,
  refer: Gift,
  eye: Eye,
  eyeOff: EyeOff,
  gridPlus: Grid2x2Plus,
  stickyNote: StickyNote,
  table: Table,
  squareSplitHorizontal: SquareSplitHorizontal,
  squareArrowOutUpRight: SquareArrowOutUpRight,
  eraser: Eraser,
  rows: Rows3,
  rows2: Rows2,
  rows4: Rows4,
  columns: Columns3,
  video: Video,
  googleMeet: GoogleMeetIcon,
  zoom: ZoomIcon,
  microsoftTeams: MicrosoftTeamsIcon,
  slack: SlackIcon,
  todoist: TodoistIcon,
  webex: WebexIcon,
  whereby: WherebyIcon,
  goToMeeting: GoToMeetingIcon,
  merge: Merge,
  zoho: ZohoIcon,
  datadog: DatadogIcon,
  metabase: MetabaseIcon,
  snowflakeBrand: SnowflakeBrandIcon,
  briefcase: Briefcase,
  building: Building2,
  presentation: Presentation,
  chartLine: LineChart,
  chartPie: PieChart,
  target: Target,
  trophy: Trophy,
  award: Award,
  flag: Flag,
  gem: Gem,
  handshake: Handshake,
  megaphone: Megaphone,
  graduationCap: GraduationCap,
  server: Server,
  cpu: Cpu,
  laptop: Laptop,
  smartphone: Smartphone,
  cloud: Cloud,
  wifi: Wifi,
  wrench: Wrench,
  hammer: Hammer,
  scissors: Scissors,
  palette: Palette,
  key: KeyRound,
  phone: Phone,
  heart: Heart,
  smile: Smile,
  coffee: Coffee,
  utensils: Utensils,
  pizza: Pizza,
  cake: Cake,
  shoppingBag: ShoppingBag,
  shoppingCart: ShoppingCart,
  shirt: Shirt,
  dumbbell: Dumbbell,
  bike: Bike,
  music: Music,
  gamepad: Gamepad2,
  film: Film,
  ticket: Ticket,
  leaf: Leaf,
  flower: Flower2,
  sprout: Sprout,
  tree: TreePine,
  snowflake: Snowflake,
  flame: Flame,
  droplet: Droplet,
  waves: Waves,
  mountain: Mountain,
  dog: Dog,
  compass: Compass,
  map: Map,
  mapPin: MapPin,
  plane: Plane,
  car: Car,
  truck: Truck,
  ship: Ship,
  stethoscope: Stethoscope,
  microscope: Microscope,
  flask: FlaskConical,
  atom: Atom,
  alarmClock: AlarmClock,
  bell: Bell,
  image: Image,
  handCoins: HandCoins,
  chartGantt: ChartGantt,
  chartNoAxesCombined: ChartNoAxesCombined,
  landmark: Landmark,
  briefcaseBusiness: BriefcaseBusiness,
  package: Package,
  banknote: Banknote,
  scale: Scale,
  gauge: Gauge,
  listChecks: ListChecks,
  shoppingBasket: ShoppingBasket,
  partyPopper: PartyPopper,
  hatGlasses: HatGlasses,
  penLine: PenLine,
  clockFading: ClockFading,
  piggyBank: PiggyBank,
  swords: Swords,
  pawPrint: PawPrint,
  chefHat: ChefHat,
  bicepsFlexed: BicepsFlexed,
  lifeBuoy: LifeBuoy,
  treePalm: TreePalm,
  cookie: Cookie,
  trees: Trees,
  ghost: Ghost,
  shield: Shield,
  shieldCheck: ShieldCheck,
  shieldQuestionMark: ShieldQuestionMark,
  shuffle: Shuffle,
  pencilSparkles: PencilSparkles,
  faceSmiling: FaceSlightlySmiling,
  micAudioLines: MicAudioLines,
  fish: Fish,
  tentTree: TentTree,
  chessKnight: ChessKnight,
  gitPullRequest: GitPullRequest,
  guitar: Guitar,
  piano: Piano,
  feather: Feather,
  galleryVerticalEnd: GalleryVerticalEnd,
  bird: Bird,
  birdhouse: Birdhouse,
  rocket: Rocket,
  bug: Bug,
  database: Database,
  monitor: Monitor,
  brain: Brain,
  zap: Zap,
  pencil: Pencil,
  users: Users,
  mic: Mic,
  headphones: Headphones,
  gift: Gift,
  sun: Sun,
  moon: Moon,
  telescope: Telescope,
  chartBar: BarChart2,
  globe: Globe,
} as const;

export type IconName = keyof typeof iconRegistry;

export { iconRegistry as Icons };
